import { initMap, equalCols } from '../functions';
import Swal from 'sweetalert2'

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};



const animateCSS = (element, animation, prefix = 'animate__') =>
// We create a Promise and return it
new Promise((resolve, reject) => {
	const animationName = `${prefix}${animation}`;
	const elements = document.querySelectorAll(element);

	elements.forEach((element) => {
		element.classList.add(`${prefix}animated`, animationName);
  
		function handleAnimationEnd(event) {
		  event.stopPropagation();
		  element.classList.remove(`${prefix}animated`, animationName);
		  resolve('Animation ended');
		}
  
		element.addEventListener('animationend', handleAnimationEnd, { once: true });
	  });
});

$(document).ready(function() {

	$('.select2').select2();

	$('.date-picker').datepicker({
        autoclose: true
    });

	if ($(".section-scroll").length)
	{
		const ps = new PerfectScrollbar('.section-scroll', {
			wheelSpeed: 2,
			wheelPropagation: true,
			minScrollbarLength: 33,
			suppressScrollX: true,
		});
	}

	var header = document.querySelector("#navbar-header");

      window.addEventListener("scroll", function () {
        if (window.scrollY > 150) {
          header.classList.add("active");
        } else {
          header.classList.remove("active");
        }
	});
	if ($("#title-split").length)
	{
		// Get the text content
		var text = document.getElementById("title-split").textContent;
	
		// Split the text into an array of words
		var words = text.split(' ');
	
		// Create a new HTML content with each word wrapped in a <span> element
		var newContent = words.map(function(word) {
			return '<span>' + word + '</span>';
		}).join('');
	
		// Set the new content back to the element
		document.getElementById("title-split").innerHTML = newContent;
	}


	// Set up the Intersection Observer
	var observer = new IntersectionObserver(handleIntersection, { threshold: 0.5 });

	// Target elements
	var targetElements = document.querySelectorAll('.divider');
	

	// Function to be called when a target element comes into view
	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				// Call your function here
				animateCSS('.divider-left', 'fadeInLeft');
				animateCSS('.divider-right', 'fadeInRight');
				animateCSS('.divider-image', 'zoomIn');
				animateCSS('.divider-side', 'zoomIn');
			}
		});
	}

	// Start observing each target element
	targetElements.forEach(element => {
		observer.observe(element);
	});

    // Toggle the height on button click
	$('.toggle-text').click(function() {
		var containerId = $(this).data('target');
		var container = $('#' + containerId);
		container.toggleClass('active');
		// var fullHeight = container.css('max-height', 'auto').height();
		// container.css('max-height', container.css('max-height') === '100px' ? fullHeight + 'px' : '100px');
		// Toggle button text
		var defaultText = $(this).data('default-text');
      	var clickedText = $(this).data('clicked-text');

		$(this).text($(this).text() === defaultText ? clickedText : defaultText);
	  });

	// const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
	// const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

	// Initialize all tooltips
	// Select the hotspot button
	
    // Initialize tooltip
    // new bootstrap.Tooltip(hotspotButton);
    const hotspotButtons = document.querySelectorAll('.hotspot');
	const tooltipList = [...hotspotButtons].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    // Initialize all collapse elements (Bootstrap does this automatically, but you may add this if necessary)

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js